import { render, staticRenderFns } from "./SprEventCollapsible.vue?vue&type=template&id=041056b8&scoped=true"
import script from "./SprEventCollapsible.vue?vue&type=script&lang=ts"
export * from "./SprEventCollapsible.vue?vue&type=script&lang=ts"
import style0 from "./SprEventCollapsible.vue?vue&type=style&index=0&id=041056b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041056b8",
  null
  
)

export default component.exports